import React from 'react';
import PropTypes from 'prop-types';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import {
  CREDIT_NOTE_MOTIVES,
  CREDIT_NOTE_MOTIVES_TICKET,
} from '../../../../config/constants';
import { isRequired } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';

const selector = formValueSelector('BaggageCreateCreditNoteForm');

const sortSelectOptions = (options) =>
  options.sort((a, b) => a.label.localeCompare(b.label));

const BaggageCreateCreditNoteForm = ({
  handleSubmit,
  baggage,
  creditNoteMotiveValue,
}) => (
  <Form onSubmit={handleSubmit}>
    <ResourceProperty label="Serie:">
      {baggage.excessBaggage.documentSeries}
    </ResourceProperty>
    <ResourceProperty label="Código:">
      {baggage.excessBaggage.documentCode}
    </ResourceProperty>
    <ResourceProperty label="Origen:">
      {baggage.sourceLocation.name}
    </ResourceProperty>
    <ResourceProperty label="Destino:">
      {baggage.destinationLocation.name}
    </ResourceProperty>
    <hr />
    <FormGroup row>
      <FormItem label="Motivo de Generación" required>
        <Field
          name="creditNoteMotive"
          component={Select}
          options={sortSelectOptions(enumToSelectOptions(CREDIT_NOTE_MOTIVES))}
          placeholder="Motivo de Generación"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    {creditNoteMotiveValue &&
      creditNoteMotiveValue.value ===
        CREDIT_NOTE_MOTIVES_TICKET.OTHERS.value && (
        <FormGroup row>
          <FormItem label="Observación de Generación" required>
            <Field
              name="creditNoteMotiveDescription"
              component={TextInput}
              type="textarea"
              placeholder="Observación de Generación"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      )}
    <FormFooter />
  </Form>
);

BaggageCreateCreditNoteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  baggage: PropTypes.shape({
    id: PropTypes.number,
    sourceLocation: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    destinationLocation: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    excessBaggage: PropTypes.shape({
      id: PropTypes.number,
      documentSeries: PropTypes.string,
      documentCode: PropTypes.string,
    }),
  }),
  creditNoteMotiveValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
};

BaggageCreateCreditNoteForm.defaultProps = {
  baggage: null,
  creditNoteMotiveValue: undefined,
};

const mapStateToProps = (state) => ({
  creditNoteMotiveValue: selector(state, 'creditNoteMotive'),
});

const form = reduxForm({
  form: 'BaggageCreateCreditNoteForm',
})(BaggageCreateCreditNoteForm);

export default connect(mapStateToProps)(form);
